import { Component, Input, OnInit, OnChanges, SimpleChanges, ChangeDetectorRef } from '@angular/core';
import { Capteur } from '../../services/capteurs.service';
import { CartouchesService } from '../../services/cartouches.service';

@Component({
  selector: 'app-capteur-modale',
  templateUrl: './capteur_modale.component.html',
  styleUrls: ['./capteur_modale.component.scss']
})
// On utilise OnChanges pour détecter tout changement d'input (capteur ou visible)
export class CapteurModaleComponent implements OnInit, OnChanges {
  @Input() capteur: Capteur | null = null;
  @Input() visible: boolean = false;
  @Input() onClose: () => void = () => {};

  nomCartoucheA: string = '';
  nomCartoucheB: string = '';

  private lastCapteurIdA: number|null|undefined = undefined;
  private lastCapteurIdB: number|null|undefined = undefined;

  constructor(
    private cartouchesService: CartouchesService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.updateCartoucheNoms();
  }

  ngOnChanges(changes: SimpleChanges) {
    // Toujours mettre à jour les noms si capteur change ou si la modale devient visible
    if ((changes['capteur'] && this.capteur) || (changes['visible'] && this.visible && this.capteur)) {
      this.updateCartoucheNoms();
    }
  }

  updateCartoucheNoms() {
    // Debug log
    console.log('[Modale] updateCartoucheNoms called', this.capteur);
    this.nomCartoucheA = '';
    this.nomCartoucheB = '';
    this.lastCapteurIdA = this.capteur?.cartouche_a;
    this.lastCapteurIdB = this.capteur?.cartouche_b;
    if (this.capteur && this.capteur.cartouche_a) {
      console.log('[Modale] Fetch nomCartoucheA for id', this.capteur.cartouche_a);
      this.cartouchesService.getNom(this.capteur.cartouche_a).subscribe({
        next: (res) => {
          this.nomCartoucheA = res.nom;
          console.log('[Modale] nomCartoucheA:', res.nom);
          this.cdr.detectChanges();
        },
        error: (err) => {
          this.nomCartoucheA = '';
          console.error('[Modale] Erreur nomCartoucheA', err);
          this.cdr.detectChanges();
        }
      });
    } else {
      this.nomCartoucheA = '';
    }
    if (this.capteur && this.capteur.cartouche_b) {
      console.log('[Modale] Fetch nomCartoucheB for id', this.capteur.cartouche_b);
      this.cartouchesService.getNom(this.capteur.cartouche_b).subscribe({
        next: (res) => {
          this.nomCartoucheB = res.nom;
          console.log('[Modale] nomCartoucheB:', res.nom);
          this.cdr.detectChanges();
        },
        error: (err) => {
          this.nomCartoucheB = '';
          console.error('[Modale] Erreur nomCartoucheB', err);
          this.cdr.detectChanges();
        }
      });
    } else {
      this.nomCartoucheB = '';
    }
  }
}
